"use client";

import { useRef, useState } from "react";
import { NextLink } from "cy-fe";
import { AnimatePresence, motion } from "framer-motion";

export function NavLinks() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const timeoutRef = useRef<number | null>(null);

  return [
    ["Features", "/#features"],
    ["Reviews", "/#reviews"],
    ["Pricing", "/#pricing"],
    ["FAQs", "/#faqs"],
  ].map(([label, href], index) => (
    <NextLink
      className="relative -mx-3 -my-2 rounded-lg px-3 py-2 text-sm text-gray-700 transition-colors delay-150 hover:text-gray-900 hover:delay-0"
      href={href}
      key={label}
      onMouseEnter={() => {
        if (timeoutRef.current) {
          window.clearTimeout(timeoutRef.current);
        }
        setHoveredIndex(index);
      }}
      onMouseLeave={() => {
        timeoutRef.current = window.setTimeout(() => {
          setHoveredIndex(null);
        }, 200);
      }}
    >
      <AnimatePresence>
        {hoveredIndex === index && (
          <motion.span
            animate={{ opacity: 1, transition: { duration: 0.15 } }}
            exit={{
              opacity: 0,
              transition: { duration: 0.15 },
            }}
            initial={{ opacity: 0 }}
            layoutId="hoverBackground"
            style={{
              position: "absolute",
              inset: 0,
              borderRadius: "0.5rem",
              backgroundColor: "rgb(243, 244, 246)",
            }}
          />
        )}
      </AnimatePresence>
      <span className="relative z-10">{label}</span>
    </NextLink>
  ));
}
